import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { AccessibleSvg } from "@/modules/theme/components/AccessibleSvg";
import { useTheme } from "@/modules/theme/hooks/useTheme";
import { grey, yellow } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

import { ReactComponent as Tick } from "./tick.svg";

type StepStatusProps = {
  done: boolean;
  statusIconDarker?: boolean;
  className?: string;
};

const translationNamespace =
  "layouts/AuthenticatedLayout/components/StepStatus";

export const StepStatus: React.FC<StepStatusProps> = ({
  done,
  statusIconDarker = false,
  className,
}) => {
  const classes = createStepStatusStyles(useTheme());
  const { t } = useTranslation(translationNamespace);
  return done ? (
    <div className={cx(classes.statusIcon, classes.done, className)}>
      <AccessibleSvg SvgComponent={Tick} title={t("Done")} />
    </div>
  ) : (
    <div
      className={cx(
        classes.statusIcon,
        statusIconDarker && classes.statusIconDarker,
        className
      )}
    />
  );
};

function createStepStatusStyles({ spacing, borderRadius }: Theme) {
  return {
    statusIcon: css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: grey[200],
      marginRight: spacing(1),
      width: 15,
      height: 15,
      borderRadius: borderRadius.round,
    }),
    statusIconDarker: css({
      backgroundColor: grey[300],
    }),
    done: css({
      backgroundColor: yellow[200],
    }),
  };
}
